module.exports = __webpack_public_path__ + "img/arraow__back.65f97219.svg";